import { CompactUserResponse, RoleCount, SubcontractorStatus, UserResponse, UserRole } from '@business/entities/account';

export function getRoleName(role: UserRole) {
  switch (role) {
    case UserRole.admin:
      return 'Admin';
    // case UserRole.client:
    //   return 'Customer';
    case UserRole.user:
      return 'Staff';
    // case UserRole.affiliate:
    //   return 'Affiliate';
    // case UserRole.noLogin:
    //   return 'No Login';
    case UserRole.subcontractor:
      return 'SubContractor';
    case UserRole.ClientPortal:
      return 'Client';
    case UserRole.salesRep:
      return 'Sales Rep';
    case UserRole.estimator:
      return 'Estimator';
  }
  return role;
}
export function getStatus(status: SubcontractorStatus) {
  switch (status) {
    case SubcontractorStatus.active:
      return 'Active';
    case SubcontractorStatus.inactive:
      return 'Inactive';
    case SubcontractorStatus.invited:
      return 'Invited';
    case SubcontractorStatus.revisionRequired:
      return 'Revision Required';
    case SubcontractorStatus.underReview:
      return 'Under Review';
    case SubcontractorStatus.awaitingSubmission:
      return 'Awaiting Submission';
    case SubcontractorStatus.applicationApproved:
      return 'Approved';
    case SubcontractorStatus.applicationRejected:
      return 'Rejected';
    case SubcontractorStatus.reviewRejected:
      return 'Revisions Required';
  }
  return status;
}
export function getStatusIndex(status: SubcontractorStatus) {
  switch (status) {
    case SubcontractorStatus.applicationApproved:
      return 0;
    case SubcontractorStatus.applicationRejected:
      return 1;
    case SubcontractorStatus.reviewRejected:
      return 2;
    case SubcontractorStatus.underReview:
      return 3;
  }
  return status;
}

export function getBadgeColor(value: SubcontractorStatus) {
  switch (value) {
    case SubcontractorStatus.active:
      return 'primary';
    case SubcontractorStatus.underReview:
      return 'warning';
    case SubcontractorStatus.revisionRequired:
      return 'warning';
    case SubcontractorStatus.underReview:
      return 'warning';
    case SubcontractorStatus.inactive:
      return 'danger';
    case SubcontractorStatus.applicationRejected:
      return 'danger';
    case SubcontractorStatus.applicationApproved:
      return 'success';
    default:
      return 'primary';
  }
}

export function getSubContractorItems() {
  return getAllSubContractorStatus().map(type => ({ label: getStatus(type), value: type }));
}
/**
 * Icon for a subcontractor's account status (Review & Submit tab, Account Status line): green tick once approved,
 * hourglass while under review, warning when changes are requested, red cross when rejected, paper plane while the
 * application hasn't been submitted yet. `title` is the tooltip.
 */
export function getSubcontractorStatusIcon(accountStatus: string | number | null | undefined): { icon: string; title: string } | null {
  switch (accountStatus?.toString()) {
    case SubcontractorStatus.applicationApproved:
      return { icon: 'fa fa-check-circle text-success', title: 'Approved' };
    case SubcontractorStatus.underReview:
      return { icon: 'fa fa-hourglass-half text-warning', title: 'Under review' };
    case SubcontractorStatus.revisionRequired:
    case SubcontractorStatus.reviewRejected:
      return { icon: 'fa fa-exclamation-circle text-warning', title: 'Changes requested' };
    case SubcontractorStatus.applicationRejected:
      return { icon: 'fa fa-times-circle text-danger', title: 'Rejected' };
    case SubcontractorStatus.awaitingSubmission:
    case SubcontractorStatus.invited:
      return { icon: 'fa fa-paper-plane text-muted', title: 'Not submitted yet' };
    default:
      return null;
  }
}

// True when the application is already submitted (Under Review) or approved: "Submit Application" is disabled.
// A revision request (revisionRequired / reviewRejected = single-tab revision) is NOT "submitted": the subcontractor
// fixes the flagged forms, reviews everything and resubmits with this button (form saves no longer auto-resubmit).
export function isApplicationSubmit(accountStatus: string | number): boolean {
  const statusString = accountStatus?.toString();
  return [SubcontractorStatus.underReview, SubcontractorStatus.applicationApproved].includes(statusString as SubcontractorStatus);
}

export function getAllSubContractorStatus() {
  return [
    // SubcontractorStatus.active,
    // SubcontractorStatus.inactive,
    // SubcontractorStatus.invited,
    // SubcontractorStatus.revisionRequired,
    // SubcontractorStatus.underReview,
    // SubcontractorStatus.awaitingSubmission,
    SubcontractorStatus.applicationApproved,
    SubcontractorStatus.applicationRejected,
  ];
}

export function getRoleColor(role: UserRole) {
  switch (role) {
    case UserRole.admin:
      return 'primary';
    case UserRole.client:
      return 'info';
    case UserRole.user:
      return 'dark';
  }
}

export function getRoles() {
  return [
    UserRole.user,
    UserRole.admin,
    // UserRole.client,
    UserRole.affiliate,
    UserRole.subcontractor,
    UserRole.ClientPortal,
    UserRole.salesRep,
  ];
}

export function staffRoles() {
  return [UserRole.user, UserRole.admin, UserRole.salesRep, UserRole.estimator];
}

export function isStaff(user: UserResponse | CompactUserResponse | RoleCount) {
  return (
    user.role === UserRole.admin ||
    user.role === UserRole.user ||
    user.role === UserRole.salesRep ||
    user.role === UserRole.estimator
  );
}

export function getRoleCount(counts: RoleCount[], roles: UserRole[]) {
  const roleCount = counts.filter(r => roles.includes(r.role));
  return roleCount.reduce((acc, r) => acc + r.total, 0);
}
